import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://api.admin.plasoft.com.br/landing/side/',
});